import React, { ReactNode } from 'react';
import styled from 'styled-components';

export interface ButtonProps {
  children: ReactNode;
  className?: string;
  textSize?: number;
  handleClick: () => void;
}

const Wrapper = styled.div`
  position: relative;
`;

const StyledButton = styled.button<{ textSize: number; }>`
  position: absolute;
  top: -10px;
  left: 0;
  font-family: ${({ theme }) => theme.family};
  font-size: ${({ textSize}) => textSize}px;
  font-weight: 700;
  background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-fill-color: transparent;
  line-height: 1;
  border: 0;
  outline: none;
  cursor: pointer;
  transition: all 300ms ease;
  padding: 0;
  z-index: 10;
  
  &:hover {
    top: 0;
    color: #FFFFFF;
    -webkit-text-fill-color: #FFFFFF;
    text-fill-color: #FFFFFF;
  }
`;

const Back = styled.div<{ textSize: number; }>`
  font-size: ${({ textSize}) => textSize}px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.3);
  line-height: 1;
`;

export const Button: React.FC<ButtonProps> = ({ children, className, textSize = 225, handleClick }) => (
  <Wrapper className={className}>
    <StyledButton textSize={textSize} onClick={handleClick}>{children}</StyledButton>
    <Back textSize={textSize}>{children}</Back>
  </Wrapper>
);
